import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Icon from '../../../../components/Icon';

const StyledFactsIcon = styled(Icon)`
  width: ${({ isMobile }) => (isMobile ? '80%' : '60%')};

  ${({ type, isMobile }) =>
    type === 'funicular' &&
    `
    width: ${isMobile ? '60%' : '45%'};
    margin-left: 2px;
  `}

  ${({ type, isMobile }) =>
    type === 'ski-in-ski-out' &&
    `
    width: ${isMobile ? '70%' : '55%'};
    margin-right: 2px;
  `}

  ${({ type }) =>
    type === 'wave' &&
    `
    width: 50%;
  `}
`;

const FactsIcon = ({ type, isMobile }) => (
  <StyledFactsIcon type={type} isMobile={isMobile} />
);

FactsIcon.propTypes = {
  type: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default FactsIcon;
